<template>
  <section>
    <h3>Atendimento</h3>
    <p>Atendimentos presenciais em Blumenau e online para todo o Brasil.</p>

    <h3>Especialidades</h3>
    <ul>
      <li>Psicoterapia Humanista / ACP</li>
      <li>Adolescentes, adultos e idosos</li>
      <li>Escuta acolhedora e desenvolvimento emocional</li>
      <li>Promoção de autoconhecimento e saúde mental</li>
    </ul>
  </section>
</template>

<style scoped>
ul {
  padding-left: 20px;
}
li {
  line-height: 1.7;
  margin-bottom: 6px;
}
</style>
